import { render, staticRenderFns } from "./Amap.vue?vue&type=template&id=5cab88b9&scoped=true&lang=html&"
import script from "./Amap.vue?vue&type=script&lang=js&"
export * from "./Amap.vue?vue&type=script&lang=js&"
import style0 from "./Amap.vue?vue&type=style&index=0&id=5cab88b9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab88b9",
  null
  
)

export default component.exports